/**
 * Javascript file for the page with details on the current business model.
 * @author Adrian Rebmann, Yannik Sprengart, Steffen Schuhmann
 */

import {
  getBmaByHash,
  getTechnologiesForBmas,
  getProjectsForBmas
} from "../../../../api";

export default {
  name: "BusinessModelDetail",
  props: ["hash"],

  /**
   * The vue instance's data object.
   * @property {boolean} loading - Information is currently being processed
   * @property {object} bma - The business model aspects.
   * @property {any[]} techrecommendations - The technology recommendations for the business model aspects.
   * @property {any[]} projects - The projects for the business model aspects.
   */
  data() {
    return {
      loading: false,
      bma: null,
      techrecommendations: [],
      projects: []
    };
  },

  /**
   * Expressions to watch.
   */
  watch: {
    $route: "fetchData"
  },

  /**
   * Called after the instance has been created.
   */
  created() {
    this.fetchData();
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    shorten(desc) {
      if (desc) {
        var res = desc.substring(0, 500) + "...";
        return res;
      } else {
        return "";
      }
    },

    /**
     * Returns to the previously visited page.
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * Fetchs data from the database.
     */
    fetchData() {
      this.techrecommendations = [];
      this.bma = null;
      this.loading = true;
      getBmaByHash(this.hash)
        .then(res => {
          getTechnologiesForBmas(this.hash).then(techn => {
            getProjectsForBmas(this.hash).then(proj => {
              this.bma = res;
              this.techrecommendations = techn;
              this.projects = proj;
              this.loading = false;
            });
          });
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/search/businessmodelsearch/detail/businessmodeldetail.js